import React from 'react';

import {Button} from "../../../components/Button";
import {TextInputField} from "../../../components/FormField";


class ChangeTitle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: this.props.title,
        };
        this.handleTitle = this.handleTitle.bind(this);
        this.submitTitle = this.submitTitle.bind(this);
    }

    handleTitle(event) {
        this.setState({title: event.target.value});
    }

    submitTitle() {
        if (this.state.title.length) {
            document.body.classList.remove('no-scroll');
            this.props.handleStatus("title", this.state.title);
            this.props.handleClose();
        }

    }

    render() {
        return (
            <div id="changeTitle" className="modal-container">
                <div className="modal-topline">
                    Titre original : <b>{this.props.title}</b>
                </div>
                <div className={"modal-body"}>
                    <TextInputField
                        onKeyPress={(event) => {event.key === "Enter" && this.submitTitle()}}
                        onChange={(event) => this.handleTitle(event)}
                        value={this.state.title}/>
                </div>
                <div className="modal-baseline">
                    <Button size={"small"}
                            btnStyle={"grey"}
                            onClick={() => this.props.handleClose()}
                            content="Annuler"/>
                    <Button size={"small"}
                            btnStyle={"primary-reverse"}
                            onClick={() => this.submitTitle()}
                            content="Valider"/>
                </div>
            </div>
        )
    }
}

export default ChangeTitle;
